import { SubscriptionProductId } from '@fruitful/types';
import { router, usePathname } from 'expo-router';
import { atom, useAtom } from 'jotai';
import { PremiumInfoSheet } from 'smoothie';

import { getPremiumUnlockedBenefits } from '../../settings/types/SubscriptionSummary';
import { useGetSubscriptionProductCatalog } from '../hooks/useSubscriptionProductCatalog';

const SUBSCRIPTION_PATH = '/settings/subscription';

export const isPremiumWelcomeSheetOpenAtom = atom(false);

/**
 * Mounted once at the app layout so it can open on top of whichever page the
 * member started their upgrade from, after the upgrade screen is popped.
 */
export const PremiumWelcomeSheet = () => {
    const [isOpen, setIsOpen] = useAtom(isPremiumWelcomeSheetOpenAtom);
    const pathname = usePathname();
    const { data: catalog } = useGetSubscriptionProductCatalog({
        subscriptionProductIds: [SubscriptionProductId.PREMIUM],
    });
    const premium = catalog?.[SubscriptionProductId.PREMIUM];

    const close = () => {
        setIsOpen(false);
    };

    return (
        <PremiumInfoSheet
            isOpen={isOpen}
            onClose={close}
            title="Welcome to Fruitful Premium"
            listTitle="You’ve unlocked:"
            listItems={
                premium != null
                    ? getPremiumUnlockedBenefits(premium)
                    : undefined
            }
            primaryAction={{
                text: 'Let’s go!',
                onPress: close,
            }}
            secondaryAction={{
                text: 'See my benefits',
                onPress: () => {
                    close();
                    if (pathname !== SUBSCRIPTION_PATH) {
                        router.push(SUBSCRIPTION_PATH);
                    }
                },
            }}
        />
    );
};
